import React, { useState, useEffect } from "react";
import Navbar from "../Dashboard/Navbar";
import "../Dashboard/dashboard.css";
import {
  useStyles,
  rowStyle as rowStyleDefault,
} from "../Dashboard/customStyles";
import { connect } from "react-redux";
import { Blocks } from "react-loader-spinner";
import Typography from "@mui/material/Typography";
import { apiGetCompanyStatisticsResult } from "../../services/api.js/backend";
import { batch } from "react-redux";
import {
  setAppIsLoading,
  setAppError,
} from "../../store/modules/appState/actions";

import {
  setSelectedStatisticsModel,
  setStatisticsData,
} from "../../store/modules/bvaStatisticsTool/actions";

import _ from "lodash";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import Backdrop from "@mui/material/Backdrop";

const BVATool = ({
  user,
  taxes,
  appState,
  setAppError,
  setAppIsLoading,
  setSelectedStatisticsModel,
  setStatisticsData,
  statisticsData,
}) => {
  let rowStyle = _.cloneDeep(rowStyleDefault);
  rowStyle = {
    ...rowStyle,
    fieldRow: { ...rowStyle.fieldRow, marginRight: "1%" },
  };
  const classes = useStyles();
  const sytleTextField = {
    backgroundColor: "transparent",
    maxWidth: "48rem",
  };
  const [modelList, setModelList] = useState([]);
  const [companyStatistics, setCompanyStatistics] = useState(
    _.cloneDeep(statisticsData.statisticsData)
  );
  const [selectedModel, setSelectedModel] = useState(
    statisticsData.selectedModel
  );

  const sectionChange = async (e) => {
    sectionUpdate(e.target.value);
  };

  const sectionUpdate = async (model) => {
    setSelectedModel(model);
  };

  const handleChange = (e, key) => {};

  const handleApply = async () => {
    try {
      let name = appState.companyData.name.replace(/,/g, "");
      name = name.replace(/ /g, "_");
      let payload = {
        companyId: appState.companyData.companyId,
        companyName: name,
      };
      batch(() => {
        setSelectedModel("");
        setCompanyStatistics([]);
        setAppIsLoading(true);
      });
      let modelResult = await apiGetCompanyStatisticsResult(payload);
      setCompanyStatistics(_.cloneDeep(modelResult));
      batch(() => {
        setAppError({ state: false, message: null });
        setAppIsLoading(false);
      });
    } catch (error) {
      batch(() => {
        setAppError({ state: true, message: error });
        setAppIsLoading(false);
      });
    }
  };

  useEffect(() => {
    if (modelList.length > 0) {
      setSelectedModel(modelList[0].id);
    } else {
      setSelectedModel("");
    }
  }, [modelList]);

  useEffect(() => {
    setSelectedStatisticsModel({
      data: _.cloneDeep(companyStatistics[selectedModel]),
      model: selectedModel,
    });
  }, [selectedModel]);

  useEffect(() => {
    setStatisticsData(_.cloneDeep(companyStatistics));
    if (companyStatistics) {
      let models = _.map(companyStatistics, (value, key, collection) => {
        return {
          id: key,
          name: key.split(".")[0],
        };
      });
      setModelList(models);
    } else {
      setModelList([]);
    }
  }, [companyStatistics]);

  return appState.isLoading ? (
    <>
      <Navbar />
      <div
        style={{ display: "flex", justifyContent: "center", margin: "30px" }}
      >
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={appState.isLoading}
        >
          {/* <CircularProgress color="inherit" /> */}
          <Blocks visible={true} height="80" width="80" />
        </Backdrop>
      </div>
    </>
  ) : appState.isError ? (
    <div>
      <Navbar />
      <Typography
        variant="h4"
        gutterBottom
        style={{ display: "flex", justifyContent: "center", margin: "30px" }}
      >
        Error. Please try again.
      </Typography>
    </div>
  ) : (
    <>
      <Navbar />
      <h2 className="settingsTxt">{"BVA Select Statistics Result"}</h2>
      <hr />
      <div className="dashboard-container">
        <div className="dashboard-top">
          <select
            value={selectedModel ? selectedModel : ""}
            className="data-select"
            id="data-select"
            onChange={(e) => sectionChange(e)}
          >
            {modelList.map((item, i) => (
              <option
                key={item.id}
                className="data-select-option"
                value={item.id}
              >
                {item.name}
              </option>
            ))}
          </select>

          <div className="dashboard-top-right">
            <button onClick={handleApply} className="saveBtn">
              Fetch Models
            </button>
          </div>
        </div>
      </div>
      {selectedModel ? (
        <>
          {/* Company Name*/}
          <div style={rowStyle.baseRow}>
            <div style={rowStyle.labelRow}>
              <InputLabel>Company Name</InputLabel>
            </div>
            <div style={rowStyle.fieldRow}>
              <TextField
                style={sytleTextField}
                InputProps={{ style: sytleTextField }}
                fullWidth
                disabled={true}
                className={classes.input}
                size="small"
                id="bva-tool-company-name"
                onChange={(e) => handleChange(e, "comnpany_name")}
                value={appState.companyData.name}
              />
            </div>
          </div>
          {/* Full Model name */}
          <div style={rowStyle.baseRow}>
            <div style={rowStyle.labelRow}>
              <InputLabel>Full Model Name</InputLabel>
            </div>
            <div style={rowStyle.fieldRow}>
              <TextField
                style={sytleTextField}
                InputProps={{ style: sytleTextField }}
                fullWidth
                disabled={true}
                className={classes.input}
                size="small"
                id="bva-tool-model-full-name"
                onChange={(e) => handleChange(e, "model_full_name")}
                value={companyStatistics[selectedModel].model_full_name}
              />
            </div>
          </div>
          {/* industry label */}
          <div style={rowStyle.baseRow}>
            <div style={rowStyle.labelRow}>
              <InputLabel>Industry</InputLabel>
            </div>
            <div style={rowStyle.fieldRow}>
              <TextField
                style={sytleTextField}
                InputProps={{ style: sytleTextField }}
                fullWidth
                disabled={true}
                className={classes.input}
                size="small"
                id="bva-tool-model-industry"
                onChange={(e) => handleChange(e, "model_industry")}
                value={
                  selectedModel
                    ? companyStatistics[selectedModel].model_industry
                    : ""
                }
              />
            </div>
          </div>
          {/* R squared label */}
          <div style={rowStyle.baseRow}>
            <div style={rowStyle.labelRow}>
              <InputLabel>{"R squared value"} </InputLabel>
            </div>
            <div style={rowStyle.fieldRow}>
              <TextField
                style={sytleTextField}
                InputProps={{ style: sytleTextField }}
                fullWidth
                disabled={true}
                className={classes.input}
                size="small"
                id="bva-tool-model-rsquared"
                onChange={(e) => handleChange(e, "model_rsquared")}
                value={
                  selectedModel
                    ? companyStatistics[selectedModel].model_rsquared
                    : ""
                }
              />
            </div>
          </div>
          {/* Independent Variables rows label */}
          {_.map(
            companyStatistics[selectedModel].model_indep,
            (value, key, collection) => {
              return (
                <div
                  key={"div-bva-tool-model-industry-" + key.replace(/ /g, "")}
                  style={rowStyle.baseRow}
                >
                  <div style={rowStyle.labelRow}>
                    <InputLabel>{"Independent Variable: " + key} </InputLabel>
                  </div>
                  <div style={rowStyle.fieldRow}>
                    <TextField
                      style={sytleTextField}
                      InputProps={{ style: sytleTextField }}
                      fullWidth
                      disabled={true}
                      className={classes.input}
                      size="small"
                      id={"bva-tool-model-industry-" + key.replace(/ /g, "")}
                      onChange={(e) => handleChange(e, "")}
                      value={value}
                    />
                  </div>
                </div>
              );
            }
          )}
          {/* Dependent variable label */}
          <div style={rowStyle.baseRow}>
            <div style={rowStyle.labelRow}>
              <InputLabel>{"Dependent Variable"} </InputLabel>
            </div>
            <div style={rowStyle.fieldRow}>
              <TextField
                style={sytleTextField}
                InputProps={{ style: sytleTextField }}
                fullWidth
                disabled={true}
                className={classes.input}
                size="small"
                id="bva-tool-dependent-variable"
                onChange={(e) => handleChange(e, "")}
                value={
                  selectedModel
                    ? companyStatistics[selectedModel].model_depen
                    : ""
                }
              />
            </div>
          </div>
          {/* Predicted value label*/}
          <div style={rowStyle.baseRow}>
            <div style={rowStyle.labelRow}>
              <InputLabel>{"Predicted Value"} </InputLabel>
            </div>
            <div style={rowStyle.fieldRow}>
              <TextField
                style={sytleTextField}
                InputProps={{ style: sytleTextField }}
                fullWidth
                disabled={true}
                className={classes.input}
                size="small"
                id="bva-tool-predicted-value"
                onChange={(e) => handleChange(e, "predicted_value")}
                value={
                  selectedModel
                    ? companyStatistics[selectedModel].predicted_value
                    : ""
                }
              />
            </div>
          </div>
        </>
      ) : (
        <Typography
          variant="h5"
          gutterBottom
          style={{ display: "flex", justifyContent: "center", margin: "30px" }}
        >
          Please click fetch button and select a model to dispay the model
          output
        </Typography>
      )}
    </>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    taxes: state.taxes,
    appState: state.appState,
    statisticsData: state.statisticsState,
  };
};

export default connect(mapStateToProps, {
  setAppError,
  setAppIsLoading,
  setSelectedStatisticsModel,
  setStatisticsData,
})(BVATool);
